import React from 'react';
import web from './Assets/social-icons-white-dribbble.svg';
import Twitter from './Assets/social-icons-white-twitter.svg';
import insta from './Assets/social-icons-white-instagram.svg';
import youtube from './Assets/social-icons-white-youtube.svg';
import './Footer.css'; // يفضل وضع الـ CSS في ملف منفصل كما فعلنا هنا

function Footer() {
    const SocialIcon = ({ src, alt, href }) => (
        <a href={href} target="_blank" rel="noopener noreferrer" className="social-icon-wrapper">
            <img src={src} alt={alt} />
        </a>
    );

    return (
        <footer className="main-footer">
            <div className="footer-top">
                <div className="footer-container">
                    {/* عمود اللوجو والوصف */}
                    <div className="footer-column brand-column">
                        <h2 className="footer-logo">Edu <span>Masr</span></h2>
                       
                        <div className="social-links-grid">
                            <SocialIcon src={web} alt="Website" href="#" />
                            <SocialIcon src={insta} alt="Instagram" href="#" />
                            <SocialIcon src={youtube} alt="Youtube" href="#" />
                            <SocialIcon src={Twitter} alt="Twitter" href="#" />
                        </div>
                    </div>

                    {/* عمود الروابط السريعة */}
                    <div className="footer-column links-column">
                        <h4 className="column-title">خريطة الموقع</h4>
                        <ul className="footer-links-list">
                            <li><a href="/">الرئيسية</a></li>
                        
                        </ul>
                    </div>

                    {/* عمود التواصل */}
                    <div className="footer-column contact-column">
                        <h4 className="column-title">تواصل معنا</h4>
                        <ul className="footer-links-list">
                            <li><a href="">الدعم الفني</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* الجزء السفلي (حقوق المبرمجين) */}
            <div className="footer-bottom">
                <p>
                    Developed with by 
                    <a className="dev-name" href="https://www.linkedin.com/in/youssef-abd0-601b9a2aa/"> Yousef Abdo</a> & 
                    <a className="dev-name" href="https://www.linkedin.com/in/mostafa-fayez-082b5321a/"> Mostafa Fayez</a>
                    <br />
                    All Rights Reserved © 2024
                </p>
            </div>
        </footer>
    );
}

export default Footer;